(() => {
    const initFatherPageReveal = () => {
      const revealItems = document.querySelectorAll('.father-page [data-fp-reveal]:not([data-fp-reveal-ready])');
  
      if (!('IntersectionObserver' in window)) {
        revealItems.forEach((item) => {
          item.classList.add('is-visible');
          item.setAttribute('data-fp-reveal-ready', 'true');
        });
        return;
      }
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, { threshold: 0.1 });
  
      revealItems.forEach((item) => {
        item.setAttribute('data-fp-reveal-ready', 'true');
        observer.observe(item);
      });
    };
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFatherPageReveal);
    } else {
      initFatherPageReveal();
    }
  
    document.addEventListener('shopify:section:load', initFatherPageReveal);
  })();